export default __webpack_public_path__ + "static/media/2452575.7f3ee54b.jpg";